<template>
  <div class="add-product-tag">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="productTag.id ? $t('addProductTag.edit') : $t('addProductTag.add')"
      :visible.sync="dialogProductTag"
      width="40%"
      top="9vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form :label-position="labelPosition" :rules="rules" ref="productTag" label-width="80px" :model="productTag">
          <!-- 多语言选项卡 -->
          <el-row>
            <el-col :span="24">
              <el-tabs v-model="activeLanguage" @tab-click="handleLanguageTabClick">
                <el-tab-pane
                  v-for="lang in $store.state.langList"
                  :key="lang.value"
                  :label="lang.label"
                  :name="lang.value"
                >
                  <template slot="label">
                    <span>{{ lang.label }}</span>
                    <i
                      v-if="isLanguageFieldEmpty(lang.value, 'name')"
                      class="el-icon-warning"
                      style="color: #f56c6c; margin-left: 5px"
                    ></i>
                  </template>
                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>

          <el-form-item :label="$t('addProductTag.name')" prop="name">
            <el-input
              v-model="getCurrentLanguageData().name"
              :placeholder="$t('addProductTag.pName')"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- 备注信息不需要多语言 -->
          <el-form-item :label="$t('addProductTag.notes')">
            <el-input type="textarea" :rows="4" v-model="productTag.notes"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="submitForm('productTag')">{{
          $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "AddProductTag",
    props: {
      productTag: Object,
      dialogProductTag: Boolean
    },
    data() {
      return {
        labelPosition: "top",
        rules: {},
        clear: false,
        loadingForm: false,
        activeLanguage: this.$i18n.locale || "zh_CN",
        tagLanguages: [] // 存储各语言的标签数据
      };
    },
    mounted() {
      this.clear = false;
    },
    methods: {
      closeDialog() {
        this.clearValidate("productTag");
        if (this.productTag.id) {
          this.$toolUtil.clearForm(this.productTag);
        } else {
          if (this.clear) {
            this.$toolUtil.clearForm(this.productTag);
          }
        }
        this.cancel("");
      },
      openDialog() {
        // 初始化多语言数据
        this.initLanguageData();

        // 设置当前活动语言
        this.activeLanguage = this.$i18n.locale || "zh_CN";
      },
      // 初始化多语言数据
      initLanguageData() {
        // 获取系统支持的语言列表
        const langList = this.$store.state.langList || [];

        // 如果标签已有语言数据，使用现有数据
        if (this.productTag.language && this.productTag.language.length > 0) {
          this.tagLanguages = JSON.parse(JSON.stringify(this.productTag.language));

          // 确保每个语言对象中移除notes字段
          this.tagLanguages.forEach(lang => {
            if (Object.prototype.hasOwnProperty.call(lang, "notes")) {
              delete lang.notes;
            }
          });
        } else {
          // 否则为每种语言创建一个空记录
          this.tagLanguages = langList.map(lang => {
            return {
              lang: lang.value,
              name: this.productTag.name || ""
            };
          });
        }

        // 确保所有支持的语言都有对应的数据
        langList.forEach(lang => {
          if (!this.tagLanguages.some(item => item.lang === lang.value)) {
            this.tagLanguages.push({
              lang: lang.value,
              name: this.productTag.name || ""
            });
          }
        });
      },
      // 获取当前语言的标签数据
      getCurrentLanguageData() {
        let data = this.tagLanguages.find(item => item.lang === this.activeLanguage);
        if (!data) {
          // 如果没有找到当前语言的数据，创建一个新的
          data = {
            lang: this.activeLanguage,
            name: ""
          };
          this.tagLanguages.push(data);
        }
        return data;
      },
      // 切换语言
      handleLanguageTabClick(tab) {
        this.activeLanguage = tab.name;
        // 触发表单验证更新
        this.$nextTick(() => {
          this.$refs["productTag"].validateField("name");
        });
      },
      // 检查语言字段是否为空
      isLanguageFieldEmpty(langCode, field) {
        const langData = this.tagLanguages.find(item => item.lang === langCode);
        return !langData || !langData[field] || langData[field].trim() === "";
      },
      cancel(state, code) {
        this.$emit("cancel", false, state, code);
      },
      submitForm(formName) {
        // 检查是否所有必填的语言都已填写
        let hasEmptyName = false;
        this.tagLanguages.forEach(lang => {
          if (!lang.name || lang.name.trim() === "") {
            hasEmptyName = true;
          }
        });

        if (hasEmptyName) {
          this.$notify({
            title: this.$t("common.tip"),
            message: this.$t("addProductTag.pName"),
            type: "error"
          });
          return false;
        }

        // 将当前语言的名称同步到productTag中用于验证
        const currentLang = this.getCurrentLanguageData();
        this.productTag.name = currentLang.name;

        this.$refs[formName].validate(valid => {
          if (valid) {
            this.loadingForm = true;
            let url = this.$url.ProductTag.insert;
            let method = this.$method.post;
            if (this.productTag.id) {
              url = this.$url.ProductTag.update;
              method = this.$method.put;
            }

            // 添加多语言数据
            this.productTag.language = this.tagLanguages;
            // notes字段已经是productTag的直接属性，无需特殊处理

            this.$api
              .request(url, method, this.productTag)
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "success"
                  });
                  this.clear = true;
                  this.cancel(this.productTag.id ? "update" : "save");
                } else {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "warning"
                  });
                }
                this.loadingForm = false;
              })
              .catch(err => {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: err.msg,
                  type: "error"
                });
                this.loadingForm = false;
              });
          }
        });
      },
      // 清除表单校验
      clearValidate(formName) {
        this.$refs[formName].clearValidate();
      }
    }
  };
</script>

<style scoped>
  .el-tabs__header {
    margin-bottom: 15px;
  }
</style>
